import { Fleet } from './Fleet';
import { User } from '../models';

export class Haulage {
    cvr: string;
    companyName: string;
    users: User[] = [];
    fleet: Fleet;
}